import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { enTranslation, esTranslation } from "@/i18n/locales/resources";

i18n
  .use(LanguageDetector) // Detect user language first
  .use(initReactI18next) // Then pass i18n instance to react-i18next
  .init({
    resources: {
      en: { translation: enTranslation },
      es: { translation: esTranslation },
    },
    lng: localStorage.getItem("lang") || "en", // Cached Language
    fallbackLng: "en", // Fallback language
    supportedLngs: ["en", "es"],
    returnNull: false, // Default is true — set to false to fallback to key
    interpolation: {
      escapeValue: false, // React already prevents XSS
    },
    react: {
      useSuspense: false, // avoid Suspense fallback flicker
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    load: 'languageOnly', // Load only the language code (en, es) not en-US, es-ES
  });

// Expose i18n instance to window for debugging
if (typeof window !== 'undefined') {
  (window as any).i18n = i18n;
}

export default i18n;
